import SearchResults from '~/src/common/components/Search/Results';
import Seo from '~/src/common/components/Seo';
import I18n from '~/src/common/services/I18n';
import { withEnhancedGSSP } from '~/src/common/services/Networking/server/withEnhancedGSSP';
import type { NextPage } from '~/src/typings/next';

const SearchPage: NextPage = () => (
  <>
    <Seo title={I18n.t('search.results.page.title')} noIndex />
    <SearchResults />
  </>
);

export const getServerSideProps = withEnhancedGSSP(() => null);
export default SearchPage;
